// extracted by mini-css-extract-plugin
export default {"skillsBlock":"Skills_skillsBlock__exfDc","skillsContainer":"Skills_skillsContainer__mVxCE","skillsText":"Skills_skillsText__1lOPq","skills":"Skills_skills__mgWp0"};